/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { TraverserFactory } from '../factories/TraverserFactory';
import { Node } from '../models/Node';
import { ITraverser } from '../visitors/ITraverser';
import { IVisitor } from '../visitors/IVisitor';
import { TraverserDirection } from '../visitors/TraverserDirection';
import { Document } from '../models/Document';

/**
 * @author eric.wittmann@gmail.com
 * @class
 */
export class VisitorUtil {
    public static visitNode(node : Node, visitor : IVisitor) {
        node.accept(visitor);
    }

    public static visitTree(node : Node, visitor : IVisitor, direction : TraverserDirection) {
        let traverser : ITraverser = TraverserFactory.create(node.ownerDocument(), visitor, direction);
        traverser.traverse(node);
    }
}
VisitorUtil["__class"] = "io.apicurio.datamodels.core.util.VisitorUtil";



